/**
 * @param {Props} props - Props
 * @returns A React component
 */
import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import formBoiler from "../../Utils/FormBoiler"
import SearchForms from "../../SearchForms/SearchForms"
import DynamicFormTypes from "../../Types/DynamicFormsTypes"
import "./DynamicFormsHeader.css"

interface Props {
    forms: Array<DynamicFormTypes>
    formsCopy: Array<DynamicFormTypes>
    manageParentState: Function
    callParentFunction: Function
    hints: boolean
}

function DynamicFormsHeader(props: Props) {

    const DynamicFormsHeaderToolTip = (text: string) => (
        <Tooltip id={`dynamic-form-tool-tip-hide-${!props.hints}`}>
            {text}
        </Tooltip>
    )

    return (
        <div className="DynamicFormsHeader">
            <div className="DynamicFormsHeaderLeft">
                {/* <ToggleHints
                    manageState={props.manageParentState}
                    hints={props.hints}
                /> */}
                <div className="DynamicFormsHeaderSearchFormsWrapper">
                    <SearchForms
                        forms={props.forms}
                        formsCopy={props.formsCopy}
                        manageParentState={props.manageParentState}
                    />
                </div>
            </div>
            <div className="DynamicFormsHeaderRight">
                <div className="DynamicFormsHeaderAddFormWrapper">
                    <OverlayTrigger placement="left" overlay={DynamicFormsHeaderToolTip("Add a new form")}>
                        <span id="dynamic-forms-header-add-form-btn" onClick={() => props.manageParentState([{ key: "createForm", value: formBoiler }])} className="material-icons">add</span>
                    </OverlayTrigger>
                </div>
            </div>
        </div>
    )
}

export default DynamicFormsHeader